import { render, staticRenderFns } from "./IForm.vue?vue&type=template&id=42243b66&scoped=true"
import script from "./IForm.vue?vue&type=script&lang=js"
export * from "./IForm.vue?vue&type=script&lang=js"
import style0 from "./IForm.vue?vue&type=style&index=0&id=42243b66&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42243b66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42243b66')) {
      api.createRecord('42243b66', component.options)
    } else {
      api.reload('42243b66', component.options)
    }
    module.hot.accept("./IForm.vue?vue&type=template&id=42243b66&scoped=true", function () {
      api.rerender('42243b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IForm.vue"
export default component.exports